import { type AnalyticsEventProperties, TelemetryEvent } from "@workspace/telemetry";
import { orgAuthRouteLabel } from "@/features/route-auth/route-label.route-auth";

export const OrgAuthTelemetryEvent = {
  RECOVERY: TelemetryEvent.ORG_AUTH_RECOVERY,
  FINAL_FAILURE: TelemetryEvent.ORG_AUTH_FINAL_FAILURE,
} as const;

export type OrgAuthTelemetryCapture = (
  eventName: (typeof OrgAuthTelemetryEvent)[keyof typeof OrgAuthTelemetryEvent],
  properties?: AnalyticsEventProperties<
    (typeof OrgAuthTelemetryEvent)[keyof typeof OrgAuthTelemetryEvent]
  >,
) => void;

export type OrgAuthRecoveryTrigger = "session_bearer_unauthenticated" | "token_unavailable";

const SAFE_TELEMETRY_CODES = new Set([
  "clerk_token_refresh_failed",
  "clerk_token_unavailable",
  "cross_origin_request_blocked",
  "permission_denied",
  "unauthenticated",
]);

export function orgAuthRouteLabelForInput(input: RequestInfo | URL, browserOrigin: string): string {
  const value = typeof input === "string" ? input : input instanceof URL ? input.href : input.url;
  return orgAuthRouteLabel(new URL(value, browserOrigin).pathname);
}

export function safeOrgAuthTelemetryCode(code: string): string {
  if (SAFE_TELEMETRY_CODES.has(code)) return code;
  if (/^http_[1-5]\d\d$/u.test(code)) return code;
  return "other";
}

export function captureOrgAuthTelemetry(
  capture: OrgAuthTelemetryCapture | undefined,
  eventName: (typeof OrgAuthTelemetryEvent)[keyof typeof OrgAuthTelemetryEvent],
  properties: Record<string, unknown>,
): void {
  if (!capture) return;
  try {
    capture(eventName, properties);
  } catch {
    // Telemetry must never change request behavior.
  }
}
